import { Routes } from '@angular/router';
import { authGuard } from './guards/auth-guard';

import { Login } from './component/login/login';
import { HomeComponent } from './component/home/home';

import { CustomerList } from './component/customer-list/customer-list';
import { CustomerAdd } from './component/customer-add/customer-add';
import { CustomerEdit } from './component/customer-edit/customer-edit';

import { CotizacionesList } from './component/cotizaciones-list/cotizaciones-list';
import { CotizacionesAdd } from './component/cotizaciones-add/cotizaciones-add';
import { CotizacionesEdit } from './component/cotizaciones-edit/cotizaciones-edit';

import { UserList } from './component/user-list/user-list';
import { UserAdd } from './component/user-add/user-add';
import { UserEdit } from './component/user-edit/user-edit';

import { UnidadList } from './component/unidad-list/unidad-list';
import { UnidadAdd } from './component/unidad-add/unidad-add';
import { UnidadEdit } from './component/unidad-edit/unidad-edit';

import { UdcList } from './component/udc-list/udc-list';

import { RecepcionesList } from './component/recepciones-list/recepciones-list';
import { RecepcionesAdd } from './component/recepciones-add/recepciones-add';
import { RecepcionesEdit } from './component/recepciones-edit/recepciones-edit';

import { ServiceorderList } from './component/serviceorder-list/serviceorder-list';
import { ServiceorderAdd } from './component/serviceorder-add/serviceorder-add';
import { ServiceorderEdit } from './component/serviceorder-edit/serviceorder-edit';

import { SaasCockpitList } from './component/saas-cockpit-list/saas-cockpit-list';
import { SaasCompanyAdd } from './component/saas-company-add/saas-company-add';
import { CotizacionRemota } from './component/cotizacion-remota/cotizacion-remota';

export const routes: Routes = [
  // 🔐 CONTROL DE ENTRADA: Acceso obligado al Login al arrancar el Portal
  // 🔓 RUTAS PÚBLICAS: Libres de candados para poder firmarse
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: Login },

  // =========================================================================
  // 🛡️ PERÍMETRO PROTEGIDO Y SEGMENTADO POR ROLES DE LA UDC
  // =========================================================================
  
  // 🚀 TU NUEVA PÁGINA DE INICIO COMPATIBLE CON EL GUARD PERIMETRAL
  { 
    path: 'home', 
    component: HomeComponent, 
    canActivate: [authGuard],
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR', 'ROLE_MECHANIC', 'ROLE_SUPPLIER'] } // 🔓 Entran TODOS los perfiles creados
  },

  // 👥 MÓDULO CLIENTES: Entran Asesores y Administradores
  { 
    path: 'customers', 
    component: CustomerList, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },
  { 
    path: 'customers/add', 
    component: CustomerAdd, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN'] } // 🔒 Sólo el Admin crea clientes
  },
  { 
    path: 'customers/edit/:an8', 
    component: CustomerEdit, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },

  // 🚗 MÓDULO VEHÍCULOS: Entran Asesores y Administradores
  { 
    path: 'unidad', 
    component: UnidadList, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },
  { 
    path: 'unidad/add', 
    component: UnidadAdd, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },
  { 
    path: 'unidad/edit/:an8', 
    component: UnidadEdit, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },

  // MÓDULO COTIZACIONES
  { 
    path: 'cotizaciones', 
    component: CotizacionesList, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },
  { 
    path: 'cotizaciones/add', 
    component: CotizacionesAdd, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },
  { 
    path: 'cotizaciones/edit/:id', 
    component: CotizacionesEdit, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },

  // MÓDULO ORDES DE SERVICIO
  { 
    path: 'ordenesdeservicio', 
    component: ServiceorderList, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },
  { 
    path: 'ordenesdeservicio/add', 
    component: ServiceorderAdd, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },
  { 
    path: 'ordenesdeservicio/edit/:id', 
    component: ServiceorderEdit, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },

  // MÓDULO UDCS: Entran Asesores y Administradores
  { 
    path: 'admin/udcs', 
    component: UdcList, 
    canActivate: [authGuard],     
    data: { rolesPermitidos: ['ROLE_ADMIN'] }
  },

  // 📋 MÓDULO RECEPCIONES (ÓRDENES DE ENTRADA): Entran Asesores y Administradores
  { 
    path: 'recepciones', // El grid principal que nos faltaría programar
    component: RecepcionesList, // Temporalmente apunta aquí en lo que lo creamos
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },
  { 
    path: 'recepciones/add', 
    component: RecepcionesAdd, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },
  { 
    path: 'recepciones/edit/:id', 
    component: RecepcionesEdit, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR'] } 
  },  

  // 🛠️ MÓDULO ÓRDENES DE SERVICIO (TALLER JDE PRODUCTION)
  // 🚀 INYECTADO: Asegura el acceso legal a las pantallas de ejecución de mecánicos/laminadores
  {
    path: 'taller/orders',
    component: ServiceorderList,
    canActivate: [authGuard],
    data: { rolesPermitidos: ['ROLE_ADMIN', 'ROLE_ASESOR', 'ROLE_MECHANIC'] }
  },

  // 🔑 MÓDULO SEGURIDAD MÁSTER: ¡ESTRICTAMENTE EXCLUSIVO PARA EL ADMINISTRADOR!
  { 
    path: 'admin/users', 
    component: UserList, 
    canActivate: [authGuard], 
    data: { 
      rolesPermitidos: ['ROLE_ADMIN'],
      prerender: false // 🚀 INYECTADO ADAPTADO: Apaga el pre-cómputo estático en servidor
    }
  },
  { 
    path: 'admin/users/add', 
    component: UserAdd, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN'] } 
  },
  { 
    path: 'admin/users/edit/:an8', 
    component: UserEdit, 
    canActivate: [authGuard], 
    data: { rolesPermitidos: ['ROLE_ADMIN'] } 
  },

  // =========================================================================
  // 👑 COCKPIT GLOBAL: SÚPER ADMINISTRADOR SaaS MÁSTER (Task D-4)
  // =========================================================================
  // 🚀 INYECTADO DE FORMA CORRECTA AL PIE DEL ENREJADO MÁSTER DEL PORTAL
  {
    path: 'admin/saas',
    component: SaasCockpitList,
    canActivate: [authGuard],
    data: { rolesPermitidos: ['ROLE_SUPER_ADMIN'] } // Candado perimetral inviolable
  },
  {
    path: 'admin/saas/add',
    component: SaasCompanyAdd,
    canActivate: [authGuard],
    data: { rolesPermitidos: ['ROLE_SUPER_ADMIN'] } // Candado perimetral inviolable
  },

  { 
    path: 'cotizacion-remota/:token', 
    component: CotizacionRemota
  },

  // 🚨 ESCAPE DE SEGURIDAD: Cualquier URL extraña rebota al Login de forma preventiva
  { path: '**', redirectTo: 'login' }
];